export const getPointConfigBarPress = (name) => {
    return {
        id: "78mmbl",
        type: "point",
        config: {
            dataId: "bar_press",
            label: name,
            color: [119, 119, 119],
            highlightColor: [252, 242, 26, 255],
            columns: {
                lat: "lat",
                lng: "lon",
                altitude: null,
            },
            isVisible: true,
            visConfig: {
                radius: 6,
                fixedRadius: false,
                opacity: 0,
                outline: false,
                thickness: 2,
                strokeColor: null,
                colorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#5A1846",
                        "#900C3F",
                        "#C70039",
                        "#E3611C",
                        "#F1920E",
                        "#FFC300",
                    ],
                },
                strokeColorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#5A1846",
                        "#900C3F",
                        "#C70039",
                        "#E3611C",
                        "#F1920E",
                        "#FFC300",
                    ],
                },
                radiusRange: [0, 50],
                filled: true,
            },
            hidden: false,
            textLabel: [
                {
                    field: null,
                    color: [255, 255, 255],
                    size: 18,
                    offset: [0, 0],
                    anchor: "start",
                    alignment: "center",
                },
            ],
        },
    }
}

export const getPointConfigBarPressHeatmap = (name, opacity = 0.8) => {
    return {
        id: "78mmbl",
        type: "point",
        config: {
            dataId: "bar_press",
            label: name,
            color: [179, 173, 158],
            highlightColor: [252, 242, 26, 255],
            columns: {
                lat: "lat",
                lng: "lon",
                altitude: null,
            },
            isVisible: true,
            visConfig: {
                radius: 10,
                fixedRadius: false,
                opacity: opacity,
                outline: false,
                thickness: 2,
                strokeColor: null,
                colorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#ffffcc",
                        "#d9f0a3",
                        "#addd8e",
                        "#78c679",
                        "#31a354",
                        "#006837",
                    ],
                },
                strokeColorRange: {
                    name: "Global Warming",
                    type: "sequential",
                    category: "Uber",
                    colors: [
                        "#ffffcc",
                        "#d9f0a3",
                        "#addd8e",
                        "#78c679",
                        "#31a354",
                        "#006837",
                    ],
                },
                radiusRange: [0, 50],
                filled: true,
            },
            hidden: false,
            textLabel: [
                {
                    field: null,
                    color: [255, 255, 255],
                    size: 18,
                    offset: [0, 0],
                    anchor: "start",
                    alignment: "center",
                },
            ],
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",

        },

        visualChannels: {
            colorField: {
                name: "data_norm",
                type: "real",
            },
            colorScale: "quantize",
            strokeColorField: null,
            strokeColorScale: "quantize",
            sizeField: null,
            sizeScale: "linear",
        }
    }


}